export default "__VITE_ASSET__BCmV78Nk__"